export const getDoctorData = (store) => store.doctorform.editData;
export const getAreaList = (store) => store.doctorform.filters.area;
export const getConsultList = (store) => store.doctorform.filters.consult;
